import client from "./http.client"
import store from "@/store"
class SettingsService {
  async getMetricColors() {
    return client.get(`/api/organizations/${store.state.organization.id}/metrics-color-ranges/`)
  }
  async addMetricColors(data) {
    return client.post(`/api/organizations/${store.state.organization.id}/metrics-color-ranges/`, data)
  }
  async updateMetricColors(id, data) {
    return client.put(`/api/organizations/${store.state.organization.id}/metrics-color-ranges/${id}/`, data)
  }

  async deleteMetricColors(id) {
    return client.delete(`/api/organizations/${store.state.organization.id}/metrics-color-ranges/${id}/`)
  }

  async getModulesSettings() {
    return client.get(`/api/organizations/${store.state.organization.id}/modules-settings/`)
  }
  async updateModuleSettings(id, data, method = "patch") {
    if (method == "patch") {
      return client.patch(`/api/organizations/${store.state.organization.id}/modules-settings/${id}/`, data)
    } else {
      return client.put(`/api/organizations/${store.state.organization.id}/modules-settings/${id}/`, data)
    }
  }
  async getModuleSettings(id) {
    return client.get(`/api/organizations/${store.state.organization.id}/modules-settings/${id}/`)
  }
  async deleteForecastingMapping(id) {
    return client.delete(`/api/organizations/${store.state.organization.id}/forecasting-mappings/${id}/`)
  }
  async resetForecastingMapping(id) {
    return client.post(`/api/organizations/${store.state.organization.id}/forecasting-mappings/${id}/reset/`)
  }
  async resyncForecastingMapping(id) {
    return client.post(`/api/organizations/${store.state.organization.id}/forecasting-mappings/${id}/resync/`)
  }
  async snapshotForecastingMapping(id) {
    return client.post(`/api/organizations/${store.state.organization.id}/forecasting-mappings/${id}/snapshot/`)
  }
  async updateForecastingMapping(id, data, method = "patch") {
    if (method == "patch") {
      return client.patch(`/api/organizations/${store.state.organization.id}/forecasting-mappings/${id}/`, data)
    } else {
      return client.put(`/api/organizations/${store.state.organization.id}/forecasting-mappings/${id}/`, data)
    }
  }
  async createForecastingMapping(data) {
    return client.post(`/api/organizations/${store.state.organization.id}/forecasting-mappings/`, data)
  }
}

export default new SettingsService()
